import { useSelector } from 'react-redux';
import { Typography } from '@mui/material';
import { getIsSingleFile } from 'store';
import DictionarySettings from './DictionarySettings';
import FullPageGraphicZoneSettings from './FullPageGraphicZoneSettings';
import BarcodeSettings from './BarcodeSettings';
import BrailleSettings from './BrailleSettings';
import TextSettings from './TextSettings';
import FontSizeSettings from './FontSizeSettings';
import ColorCheckSettings from './ColorCheckSettings';
import styles from './SettingsContent.module.css';

const SettingCategory = ({ children, title }: { children: React.ReactNode; title: string }) => {
  return (
    <div className={styles.category}>
      <Typography variant="body1" color="text.secondary" className={styles.title}>
        {title}
      </Typography>
      <div className={styles.settings}>{children}</div>
    </div>
  );
};

const SettingsContent = () => {
  const isSingleFile = useSelector(getIsSingleFile);

  return (
    <div className={styles.root}>
      {!isSingleFile && (
        <SettingCategory title="Both Documents">
          <TextSettings />
          <FullPageGraphicZoneSettings />
        </SettingCategory>
      )}
      <SettingCategory title="New Document">
        <DictionarySettings />
        <BarcodeSettings />
        <BrailleSettings />
        <FontSizeSettings />
        <ColorCheckSettings />
      </SettingCategory>
    </div>
  );
};

export default SettingsContent;
